import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PaginationControlsWrapper, PageNumbers, PageButton, PageNumber } from './style';
var Paging = function (props) {
    var defaultProps = Paging.defaultProps;
    var currentPage = props.currentPage, totalPages = props.totalPages, _a = props.numberOfPages, numberOfPages = _a === void 0 ? defaultProps.numberOfPages : _a, _b = props.previousButtonText, previousButtonText = _b === void 0 ? defaultProps.previousButtonText : _b, _c = props.nextButtonText, nextButtonText = _c === void 0 ? defaultProps.nextButtonText : _c, renderLink = props.renderLink;
    var pagesToRender = Math.min(totalPages, numberOfPages);
    var firstPageToRender = currentPage > numberOfPages / 2
        ? Math.ceil(currentPage - numberOfPages / 2)
        : 1;
    var lastPageToRender = Math.min(firstPageToRender + pagesToRender - 1, totalPages);
    var pageNumbers = [];
    for (var i = firstPageToRender; i <= lastPageToRender; i += 1) {
        pageNumbers.push(i);
    }
    return totalPages > 1 ? (_jsxs(PaginationControlsWrapper, { children: [currentPage > 1 &&
                renderLink(currentPage - 1, false, previousButtonText), _jsx(PageNumbers, { children: pageNumbers.map(function (i) {
                    return renderLink(i, i === currentPage);
                }) }), currentPage < totalPages &&
                renderLink(currentPage + 1, false, nextButtonText)] })) : null;
};
Paging.defaultProps = {
    previousButtonText: 'PREVIOUS',
    nextButtonText: 'NEXT',
    numberOfPages: 10
};
export default Paging;
export { PageButton, PageNumber };
//# sourceMappingURL=Paging.js.map